module.exports = __webpack_public_path__ + "img/plane_track_3.0cf00b3f.svg";